import { render, staticRenderFns } from "./tp1Edit.vue?vue&type=template&id=e78bc172"
import script from "./tp1Edit.vue?vue&type=script&lang=js"
export * from "./tp1Edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports